import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
var BsDatePickerContainer = (function () {
    function BsDatePickerContainer() {
    }
    BsDatePickerContainer.decorators = [
        { type: Component, args: [{
                    selector: 'bs-date-picker-container',
                    template: "<bs-datepicker></bs-datepicker>",
                    // tslint:disable
                    host: {
                        'class': 'dropdown open',
                        style: 'position: absolute;display: block;'
                    },
                    // tslint: enable
                    encapsulation: ViewEncapsulation.None,
                    changeDetection: ChangeDetectionStrategy.OnPush
                },] },
    ];
    /** @nocollapse */
    BsDatePickerContainer.ctorParameters = function () { return []; };
    return BsDatePickerContainer;
}());
export { BsDatePickerContainer };
//# sourceMappingURL=bs-date-picker-container.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker2/popup/bs-date-picker-container.component.js
// module id = 168
// module chunks = 103